import { Directive, HostListener } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[NumberValidation]',
})
export class NumberValidationDirective {
  constructor() {}
  @HostListener('keypress', ['$event'])
  public onKeyPress(event: KeyboardEvent): boolean {
    const REGEX = new RegExp('^[0-9+.]');
    const KEY = String.fromCharCode(event.charCode ? event.which : event.charCode);
    if (!REGEX.test(KEY)) {
      event.preventDefault();
      return false;
    }
    return true;
  }
}
